<template>
  <div class="dropdown">
    <!-- v-on:filter="searchItem(index, $event)" -->
    <InputText
      :id="useCustomID && index ? 'customDropdownInput' + index : 'customDropdownInput'"
      v-model.trim="searchFilter"
      required="true"
      :disabled="disabled"
      :placeholder="placeholder"
      @input="searchItem(searchFilter)"
      @focus="showOptions($event)"
      @blur="exit($event)"
      @keyup="keyMonitor"
      @keydown="keyMonitor1"
      :class="inputClass"
      autocomplete="off"
      :style="{width: '100%', textTransform: useUpperCase ? 'uppercase' : 'normal'}"
    />
    <i class="p-dropdown-clear-icon pi pi-times clearBtn" @click="selectOption({})"></i>

    <OverlayPanel 
      ref="op" 
      appendTo="body" 
      :showCloseIcon="true"
      style="width: 350px; height: 200px;"
    >
      <div 
        class="dropdown-content"
        v-show="optionsShown"
        style="height: 180px; overflow-y: scroll;"
        id="dropDownWindow"
      >
        <div
          @mousedown="selectOption(option)"
          v-for="(option, index) in filteredOptions"
          :key="index"
          :class="'pl-1 dropItem ' + addActive(index)"
        >
          {{ option[optionLabel] || option[dataKey] || '-' }} 
          <span v-if="showIds">( {{ option[dataKey] }} )</span>
        </div>
      </div>
    </OverlayPanel>
  </div>
</template>

<script>
  export default {
    name: 'Dropdown',
    template: 'Dropdown',
    props: {
      optionLabel: {
        type: String,
        required: true,
        default: 'dropdown',
        note: 'Input optionLabel'
      },
      dataKey: {
        required: true,
        default: 'id',
        note: 'Id for the data'
      },
      allOptions: {
        type: Array,
        required: true,
        default: [],
        note: 'All options of dropdown. An array of options with id and optionLabel',
      },
      placeholder: {
        type: String,
        required: false,
        default: 'Please select an option',
        note: 'Placeholder of dropdown'
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
        note: 'Disable the dropdown'
      },
      forceSelection: {
        type: Boolean,
        required: false,
        default: false,
        note: 'Force you to select from options'
      },
      showDropDownOnStart: {
        type: Boolean,
        required: false,
        default: true,
        note: 'Force you to select from options'
      },
      index: {
        type: Number,
        required: false,
        default: 0
      },
      useCustomID: {
        type: Boolean,
        requirerd: false,
        default: false,
        note: 'if this component is used more than once then same id might cause problems. index must be provided with this.'
      },
      currentValue: {
        required: true
      },
      inputClass: {
        type: Object,
        rquired: false,
        default: () => {{}}
      },
      showIds: {
        type: Boolean,
        required: false,
        default: false,
        note: 'to show ids with the names in the list'
      },
      useUpperCase: {
        type: Boolean,
        required: false,
        default: false,
        note: 'to show input in uppercase'
      }
    },
    created() {
      if (this.currentValue) {
        this.setValues(this.currentValue)
      }
    },
    data() {
      return {
        selected: {},
        choosen: new Date().getTime(),
        optionsShown: false,
        searchFilter: '',
        filteredOptions: [],
        activeIndex: null,
        lastInput: ''
      }
    },
    watch: {
      currentValue(val) {
        this.setValues(val)
      }
      // searchFilter(val) {
      //   
      // },
      // selected(val) {
      //   
      // }
    },
    methods: {
      addActive(index) {
        // 
        if (index === this.activeIndex) {
          return 'activeDrop'
        } else {
          return ''
        }
      },
      setValues(val) {
        // 
        if (typeof val === 'string') {
          this.searchFilter = val
        } else {
          this.searchFilter = val[this.optionLabel]
        }
        this.selected = val
      },
      searchItem(event) {
        // 

        if (this.allOptions && this.allOptions[0]) {
          
          if (!event.trim().length) {
            this.filteredOptions = [...this.allOptions];
          }
          else {

            this.filteredOptions = this.allOptions.filter(item => {
              // 
              if (
                item &&
                item[this.optionLabel] &&
                item[this.optionLabel].toLowerCase() &&
                event.toLowerCase() &&
                item[this.optionLabel].toLowerCase().search(event.toLowerCase()) >= 0
              ) {
                return true
              } else {
                return false
              }

            });
          }
          // 
        }
      },
      focusNextInput() {
        if (this.$el.parentNode.className === 'p-field p-col') {
          if (this.$el.parentNode.nextSibling) {
            if (this.$el.parentNode.nextSibling.tagName === 'INPUT') {
              this.$el.parentNode.nextSibling.focus()
            } else {
              if (this.$el.parentNode.nextSibling.children) {
                if (
                  this.$el.parentNode.nextSibling.children[0]
                  && this.$el.parentNode.nextSibling.children[0].tagName === 'INPUT'
                ) {
                  this.$el.parentNode.nextSibling.children[0].focus()
                } 
                else if (
                  this.$el.parentNode.nextSibling.children[1]
                  && this.$el.parentNode.nextSibling.children[1].tagName === 'INPUT'
                ) {
                  this.$el.parentNode.nextSibling.children[1].focus()
                } 
              } 
            }

          } else {
            if (this.$el.parentNode.parentNode.nextSibling) {
              if (this.$el.parentNode.parentNode.nextSibling.children) {
                if (this.$el.parentNode.parentNode.nextSibling.children[0]) {
                  if (this.$el.parentNode.parentNode.nextSibling.children[0].tagName === 'INPUT') {
                    this.$el.parentNode.parentNode.nextSibling.children[0].focus()
                  } else {
                    if (this.$el.parentNode.parentNode.nextSibling.children[0].children) {
                      if (
                        this.$el.parentNode.parentNode.nextSibling.children[0].children[0]
                        && this.$el.parentNode.parentNode.nextSibling.children[0].children[0].tagName === 'INPUT') {
                        this.$el.parentNode.parentNode.nextSibling.children[0].children[0].focus()
                      } else if (
                        this.$el.parentNode.parentNode.nextSibling.children[0].children[1]
                        && this.$el.parentNode.parentNode.nextSibling.children[0].children[1].tagName === 'INPUT') {
                        this.$el.parentNode.parentNode.nextSibling.children[0].children[1].focus()
                      }
                    }
                  }
                }
              }
            }

          }
        }
      },
      selectOption(option) {
        this.selected = option;
        this.searchFilter = this.selected[this.optionLabel];

        this.optionsShown = false;
        this.$refs.op.hide();

        this.choosen = new Date().getTime()
        this.$emit('selected', { value: this.selected, index: this.index });
      },
      // Selecting when pressing Enter
      keyMonitor1: function(event) {
        
        if (event.key !== "Tab") {
          // 
          this.goThroughtOptions(event)
          
          // 
          if (new Date().getTime() - this.choosen > 500) {
            this.$refs.op.show(event);
          }
        }

        if (event.key === 'Enter') {
          this.focusNextInput()
        }

      },
      keyMonitor: function(event) {
        if (event.key !== "Tab") {
          // 

          if (event.code === 'Space' && typeof this.searchFilter === 'string') {
            this.searchFilter = this.searchFilter.concat(' ')
          }
          if (event.code === 'Backspace' && this.lastInput && this.lastInput[this.lastInput.length - 2] === ' ') {
            this.searchFilter = this.searchFilter.concat(' ')
          }
          this.lastInput = this.searchFilter

          if (event.key !== "Enter" && !this.searchFilter) {
            this.selected = {}
            this.searchItem(this.searchFilter)
          }
          
          if (this.optionsShown === false) {
            this.optionsShown = true;
            // 
            if (new Date().getTime() - this.choosen > 500) {
              this.$refs.op.show(event);
            }
            this.activeIndex = 0;
          }

          if (this.selected instanceof Object) {
            let a = Object.keys(this.selected)
            // 
            if (!this.forceSelection && !a.length) {
              this.choosen = new Date().getTime()
              this.$emit('selected', { value: this.searchFilter, index: this.index });
            }
          } else {
            if (!this.forceSelection) {
              this.choosen = new Date().getTime()
              this.$emit('selected', { value: this.searchFilter, index: this.index });
            }
          }

            // this.goThroughtOptions(event)
        }
      },
      goThroughtOptions(event) {
        let a = document.getElementsByClassName('dropItem'), b = document.getElementById('dropDownWindow')
        if (event.key === 'ArrowDown') {
          event.preventDefault()

          // 
          // 
          
          if (this.activeIndex === null) {
            this.activeIndex = 0

          } else if (this.activeIndex + 1 < a.length) {
            this.activeIndex++
            // 
            if (a[this.activeIndex] && a[this.activeIndex]) {
              b.scrollTo(0, a[this.activeIndex].offsetTop - 20)
            }

          }
        } else if (event.key === 'ArrowUp') {
          event.preventDefault()

          if (this.activeIndex - 1 >= 0) {
            this.activeIndex--
            if (a[this.activeIndex] && a[this.activeIndex]) {
              b.scrollTo(0, a[this.activeIndex].offsetTop - 20)
            }
          }
        } else if (event.key === 'Enter') {
          this.selectOption(this.filteredOptions[this.activeIndex])
        }
      },
      showOptions(event){
        // 

        if (!this.disabled) {
          if (!this.searchFilter) {
            this.searchFilter = '';
          }
          if (this.showDropDownOnStart) {
            this.optionsShown = true;
            if (this.$refs.op) {
              // 
              if (new Date().getTime() - this.choosen < 500 || !Object.keys(this.selected).length) {
                this.$refs.op.toggle(event);
              }
            }
            this.searchItem(this.searchFilter)
          }
        }
      },
      exit(event) {
        // 
        // 
        if (!(this.selected && this.selected[this.dataKey]) && this.forceSelection) {
          this.selected = {};
          this.searchFilter = '';

        } else {
          if (this.selected && this.selected.dataKey) {
            this.searchFilter = this.selected.optionLabel
          }

        }
        if (this.optionsShown) {
          this.optionsShown = false;
          if (this.$refs.op) {
              // 
              if (!Object.keys(this.selected).length) {
              this.$refs.op.toggle(event);
            }
          }
        }
      }
    }
  };
</script>


<style lang="scss" scoped>

.clearBtn {
  position: absolute;
  right: 15px;
}

.dropItem {
  padding: 5px 0px;
}

.dropItem:hover {
  background-color: #248cc4;
  color: white;
  cursor: auto;
}

.activeDrop {
  background-color: #248cc4;
  color: white;
}

</style>
